<template >
  <div >
    <a-button @click="gatewayTransfer" :disabled="!selectedRowKeys.length" :style="{'border-style':borderStyle,'background-color': backgroundColor}">
      {{ $t('page_iot_gateway_tenant_transfer') }}
    </a-button>
    <a-modal
        :title= "$t('page_iot_gateway_tenant_transfer')"
        :visible="showTransfer"
        :body-style="{ padding: '16px 16px 0' }"
        :destroy-on-close="true"
        :maskClosable="false"
        :width="680"
        :confirmLoading="loading"
        @ok="handleOk"
        @cancel="handleCancel"
    >
      <div style="text-align: center">
        <span style="font-size: 14px;color: rgba(0, 0, 0, 0.85);font-weight: bold;margin-right: 10px;"
              :label-col="{ span: 6 }"
              :wrapper-col="{ span: 16 }">
          选择租户:
        </span>
        <app-select
            placeholder="选择目标租户"
            v-model="transferTeant"
            style="margin-right: 10px;width: 60%;margin-bottom: 8px;"
            :list="tenants"
            :show-search="true"
            :change="selectChange()"
        />
      </div>
      <div style="margin-bottom: 8px">
        <a-alert
            show-icon
            v-if="alertVisible"
            style=";width: 71%;margin: auto"
            :message="message"
            :description="description"
            :type="type"
        />
      </div>
    </a-modal>
  </div>
</template>

<script>
import {GatewayServiceProxy,GatewayTransferDTO} from "@/service-proxies/app-v2/iot-console.service-proxies";

const ecsp = new GatewayServiceProxy()
export default {
  name: "GatewayTransfer",
  data(){
    return {
      showTransfer:false,
      transferTeant:undefined,
      selectName:'',
      description :'',
      alertVisible:false,
      message: '',
      type:'warning',
      loading:false,
      hasWorkStationGateway:[]
    }
  },
  props:{
    selectedRowKeys:{},
    selectedRows:{},
    tenants:{},
    selectGatewayIds:{},
    borderStyle:{},
    backgroundColor:{},
  },
  methods : {
    gatewayTransfer(){
      this.transferTeant = undefined
      this.showTransfer = true

      this.hasWorkStationGateway = []
      for(var selectedRow of this.selectedRows){
        if (selectedRow.associateWorkStations && selectedRow.associateWorkStations.length !== 0){
          this.hasWorkStationGateway.push(selectedRow.code)
        }
      }
      if (this.hasWorkStationGateway.length > 0){
        this.description = this.hasWorkStationGateway.join(",") + " 已关联工位无法迁移"
        this.message = '无法迁移网关'
        this.type = 'warning'
        this.alertVisible = true
      }
    },
    handleOk(){

      if (this.hasWorkStationGateway.length === 0){
        if (!this.transferTeant){
          this.message = '请选择目标租户'
          this.description = ''
          this.type = 'error'
          this.alertVisible = true
        }else{
          this.loading = true
          let params = {
            gatewayIds : this.selectGatewayIds,
            newTenantId : this.transferTeant,
            newTenantName : this.selectName
          }
          const gs = new GatewayTransferDTO()
          gs.init(params)
          ecsp.gatewayTransfer(gs).then(res => {
            this.$message.success("迁移成功")
            this.$emit("getGatewayList")
          }).finally(()=>{
            this.loading = false
            this.handleCancel()
          })

        }
      }

    },
    handleCancel(){
      this.showTransfer = false
      this.alertVisible = false
    },
    selectChange(){
      let obj = {}
      obj = this.tenants.find(item => item.value === this.transferTeant)
      if (obj){
        this.selectName = obj.label
      }
    }
  },
  watch:{
    transferTeant(){
      if (this.transferTeant && this.type === 'error'){
        this.alertVisible = false
      }
    }
  }
}
</script>

<style scoped>

</style>